import { ApplicationContext } from '@upside/spa-shared-context';

import { globalHeaderAppName } from 'shell/const';
import { getAppStatus, registerApplication, LifeCycles } from 'single-spa';

/**
 * Registers global header app if the local storage feature flag is set
 */
export const registerGlobalHeader = (context: ApplicationContext): void => {
  const localFeatureFlags = JSON.parse(
    localStorage.getItem('featureflagsmap') ?? '{}',
  ) as Record<string, string>;
  if (
    getAppStatus(globalHeaderAppName) ||
    localFeatureFlags['feature-flag_show_global_header'] !== 'true'
  ) {
    return;
  }
  registerApplication({
    activeWhen: () => context.authentication.loggedIn,
    app: () => System.import(globalHeaderAppName) as Promise<LifeCycles>,
    name: globalHeaderAppName,
    customProps: {
      context,
      domElementGetter: () =>
        document.querySelector('#global-header-container'),
    },
  });
};
